import { ScoreHealthRangeBreakpoint } from '../../..';

export const BURN_RATE_SCORE_HEALTH_RANGE_BREAKPOINTS: ScoreHealthRangeBreakpoint[] = [
  { category: 'atypicallyLow', min: 0, max: 0.2, id: 'atypicallyLow_Br' },
  { category: 'low', min: 0.2, max: 0.3, id: 'low_Br' },
  { category: 'typical', min: 0.3, max: 0.5, id: 'typical_Br' },
  { category: 'elevated', min: 0.5, max: 0.7, id: 'elevated_Br' },
  { category: 'atypicallyHigh', min: 0.7, max: 1, id: 'atypicallyHigh_Br' },
];
